<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="head_1"><b>INTRO</b></p>
<p class="noindent">Arf! I’m Puddles. Sometimes I think you humans don’t have the sense God gave a gopher. You wash too much, and you don’t know a thing about the best place to bury a bone!</p>
<p class="indent">But you do have some good qualities: like fingers just right for scratching tummies and opening doors. And you taste almost as good as old shoes! I love my boy Bobby, but his mama’s eyes keep leaking salty water. I think they both need a daddy human to make them happy. As a born sheepdog, I should be able to round one up. In fact, I think the nice one down the street would suit me just fine….</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369700407_Introduction.vue?60896f5c